import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { numberFormatterForDecimalInMNew } from "../../utils/formatter";

interface TierDetail {
    tierType: string;
    startValue: number;
    endValue: number;
    benefitPercentage: number;
    progress: number;
    projection: string;
}

interface TierTableProps {
    tierDetails: TierDetail[];
    growthTierType: string;
    decimal?: number;
}


const progressBody = (row: TierDetail) =>
    row.progress >= 100 ? <span className="flex justify-center">&#10003;</span> : <span className="flex justify-center">{row.progress ? row.progress.toFixed(2) : "0.00"}%</span>;

const projectionBody = (row: TierDetail) =>
    row.projection === "On Pace" ? (
        <span className="flex justify-center" style={{ color: "green", fontWeight: 600 }}>{row.projection}</span>
    ) : row.projection === "Borderline" ? (
        <span className="flex justify-center" style={{ color: "#D4A900", fontWeight: 600 }}>{row.projection}</span>
    ) : row.projection === "Off Track" ? (
        <span className="flex justify-center" style={{ color: "red", fontWeight: 600 }}>{row.projection}</span>
    ) : (
        <span className="flex justify-center" style={{ color: "black", fontWeight: 600 }}>&#10003;</span>
    );

// const thresholdBody = (row: TierDetail) => formatThreshold(row.endValue);

const TierTable: React.FC<TierTableProps> = ({ tierDetails, growthTierType, decimal = 1 }) => {
    // zebra striping using index from the array itself
    const rowClassName = (rowData: TierDetail): string => {
        const rawIndex = tierDetails.indexOf(rowData);
        const index = rawIndex >= 0 ? rawIndex : 0;
        // 1st data row = light band, 2nd row = white (to match screenshot)
        return index % 2 === 0 ? "tier-row-light" : "tier-row-white";
    };

    return (
        <div className="w-full h-full">
            {/* top green bar */}
            <div style={{ height: 3, backgroundColor: "#a6ce39" }} />

            <DataTable
                value={tierDetails}
                showGridlines={false}
                className="p-datatable-sm tier-table"
                style={{ width: "100%", border: "none" }}
                tableStyle={{ width: "100%", tableLayout: "fixed", borderCollapse: "separate", borderSpacing: 0 }}
                rowClassName={rowClassName}
            >
                <Column field="tierType" header="Tier #" bodyClassName="font-semibold" style={{ width: "22%" }} />
                <Column header="Threshold" bodyClassName="font-semibold" style={{ width: "26%" }} body={(row) => {
                    return <div className="flex justify-center">
                        {growthTierType && growthTierType.toLowerCase().startsWith("dollar") && "$"}
                        {numberFormatterForDecimalInMNew(row.startValue, decimal)}
                        {growthTierType && growthTierType.toLowerCase().startsWith("pound") && " lbs."}
                    </div>
                }} />
                <Column header="Progress" bodyClassName="font-semibold" style={{ width: "24%" }} body={progressBody} />
                <Column header="Projection" bodyClassName="font-semibold" style={{ width: "28%" }} body={projectionBody} />
            </DataTable>
        </div>
    );
};

export default TierTable;